var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 181,
    viewBox: "0 0 182 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_10842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0295 0.246552C58.3984 2.78223 36.986 14.0871 21.9129 32.0482C11.3123 44.6561 4.72661 58.9545 1.80354 75.7182C1.1344 79.5569 1.06396 81.4234 1.06396 90.1574C1.06396 98.8914 1.1344 100.758 1.80354 104.597C5.114 123.614 13.0732 139.357 26.2094 152.986C39.6978 167.003 56.708 175.877 76.5708 179.364C80.4095 180.033 82.276 180.104 91.01 180.104C102.033 180.104 105.344 179.751 114.007 177.533C145.069 169.503 170.356 144.217 178.385 113.155C180.604 104.491 180.956 101.181 180.956 90.1574C180.956 79.1343 180.604 75.8238 178.385 67.1602C170.356 36.1334 145.069 10.8119 114.007 2.78223C106.013 0.739609 102.244 0.281769 92.4188 0.176117C87.4883 0.105682 82.8043 0.1409 82.0295 0.246552ZM138.378 51.911C141.653 53.4253 143.484 56.0667 143.766 59.5884C144.083 63.6385 145.316 62.2298 112.563 94.7357C91.7144 115.409 82.4169 124.389 81.2547 125.023C78.8247 126.291 75.5847 126.256 73.4012 124.953C71.4642 123.79 41.2122 96.2501 39.9091 94.454C37.2326 90.7561 37.8313 85.6143 41.2474 82.7969C43.8887 80.5782 47.5161 80.1908 50.5449 81.7404C51.3197 82.1278 57.5884 87.5865 64.4911 93.9257L76.9934 105.371L103.653 78.7469C118.304 64.0963 130.383 52.1223 130.454 52.1223C130.56 52.1223 131.264 51.8757 132.039 51.594C134.117 50.8544 136.37 50.9601 138.378 51.911Z",
    fill: "#33BC8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_10842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180.315,
    height: 180.315,
    fill: "white",
    transform: "translate(0.852539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f8d4b36435ab6ba13f9eae2c203c32a6.svg";
export { ForwardRef as ReactComponent };